import React from "react";
import { connect } from "react-redux";
import PieChartReport from "./PieChartReport";
import eventAdvertise from "../../../store/actions/eventAdvertise";
import activeChartConstant from "../../../store/actions/activeChart";
import BarChartReport from "./BarChartReport";
import LineChartReport from "./LineChartReport";

const ChartReport = ({ activeChart }) => {
  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-4 pb-2">
      <div>
        <select className="form-control w-auto">
          <option>{eventAdvertise.eventAdvertisePersian["VIEW"]}</option>
        </select>
      </div>
      <div>
        <div className="container-fluid pt-3 px-0">
          <div className="row">
            <div
              className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
              id="container-pie-chart-report-campaign"
            >
              <PieChartReport />
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 pt-5 pt-lg-0 ltr">
              <div>
                {activeChart == activeChartConstant.BAR && <BarChartReport />}
                {activeChart == activeChartConstant.LINE_SIMPLE && (
                  <LineChartReport />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    activeChart: state.report.active_chart,
  };
};

export default connect(mapStateToProps, {})(ChartReport);
